import { Skeleton } from '@/components/ui/skeleton';

const IncidentListsLoader = () => {
  return (
    <>
      <div className="[&>*:not(:last-child)]:border-b border-surface-border-default">
        {[...Array(12)].map((_, index) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className="flex items-start justify-between gap-2.5 pb-3 w-full max-w-full pt-3 first:pt-1"
          >
            <div className="flex items-start gap-2.5 w-full max-w-full">
              <Skeleton className="size-8 shrink-0 rounded-md" />
              <div className="flex flex-col justify-start gap-[5px] min-w-0 w-full">
                <Skeleton className="h-3.5 w-[292px] rounded-sm" />
                <Skeleton className="h-3.5 w-[292px] rounded-sm" />
                <Skeleton className="h-3.5 w-[162px] rounded-sm" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default IncidentListsLoader;
